import * as React from 'react';
const SvgClose = () => (
  <svg width={18} height={18} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.424 3.877a.6.6 0 0 1 0 .848l-9 9a.6.6 0 1 1-.848-.848l9-9a.6.6 0 0 1 .848 0Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.576 3.877a.6.6 0 0 1 .848 0l9 9a.6.6 0 0 1-.848.848l-9-9a.6.6 0 0 1 0-.848Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgClose;
